 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		1: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/chunks/" + ({"0":"framework","3":"eae6f35fcab366852a77f1f00310047e04fe07b9","5":"c9c6fe98","6":"fb2645b55c16f7869af7a7384c4bc4476b00a5cf","8":"e8adfd52c7186b74a6407fd11eaa2191ed7e5545","9":"dcea61c57d916fb4849d5b4fe47960bb2fbf6a9d","11":"e378534f944924bb957cbff13fdb9e485009d68f","12":"75fc9c18","13":"cb587b6468196656336b0d2e9a2a1e3226ab0577","18":"86d2bc18f4fbea8a72bf5642c0b8258a05baee95","20":"1b71e3b478f54a1cc4850717986c2c1e9f96663e","21":"395aefadd6d3ca46d869d681072703731c097147","26":"f929a364fc82e5f5a75c1d52bff9d61721290ab0","33":"d24c4787b894029f750df58ec5f928583a31a86e","38":"fb8e0a985f1e2798051d4965d984ea2bb1775ce2","41":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","42":"cae5737e08c1a9948a650822c6a84ae1b82f4d13","43":"d282c9243d032fb2d2ee2da709a47048b1d844db","126":"reactPlayerDailyMotion","127":"reactPlayerFacebook","128":"reactPlayerFilePlayer","129":"reactPlayerKaltura","130":"reactPlayerMixcloud","131":"reactPlayerPreview","132":"reactPlayerSoundCloud","133":"reactPlayerStreamable","134":"reactPlayerTwitch","135":"reactPlayerVidyard","136":"reactPlayerVimeo","137":"reactPlayerWistia","138":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"c79e8c1855af7b4c66de","3":"0e99139bb943e2a2cf3a","5":"f2338c2e0957ba7504e7","6":"4abf5d2f897b87c65035","8":"b1448c5e908ba4423a27","9":"263e494e16160e4a780f","11":"d9dba2ff11a6921a18cb","12":"af6c63e5da409560ce9f","13":"8da48aa9fcc3e4946fb3","18":"1bffe8895e4be92f2775","20":"9a73b6ad08dc0f94bcf8","21":"b3296d5e5d290b682c52","26":"9383f485fb35cf64e25a","33":"1661453cfe8b338f177e","38":"d81ef9faeca5a674708b","41":"9947bc3972a8148a5cbb","42":"9bcba0db7440a544fb5c","43":"f1580a22c6d2fc4366ef","44":"93b2027b42775b445352","45":"fd9e760c3c959294ff22","46":"79ade42caff3fdaefade","47":"c55a62b2d03053696bb3","48":"24014b6a84f6887aef90","49":"3a3fd514bfef193aa0ce","50":"6123868a5d221baa80b9","51":"3084da069f2c28171f75","52":"42d0af24a300d3ffeb8a","55":"613a67090df7307cf627","56":"d750a560bcfd404d976d","57":"fd29664907969893cda0","58":"21c61953f23691151e96","59":"0a667fc172031b866464","60":"db320420a53f21a953e3","61":"9d82a06f5d5a88c13938","62":"db7d28011fb43ef8cb33","63":"f4b8394a6f33d1037239","72":"7f23ec37efdb34698cd5","73":"ab669174ecd748f73aab","74":"2720eddd8c0140428340","75":"d62328eefe579971d748","76":"af52a6002765872c6309","126":"3249d3ddfe0dc38ce4cf","127":"de7378b29451345aaafc","128":"6ea65996152eee1f9db2","129":"25b3e0d2fbe4b228a872","130":"8dd8ead88d0baec85d44","131":"e9e057530968dd8c546f","132":"b24da497dc33ab029105","133":"2141c2ba5c0208bc2369","134":"47e16e7acd7d3c7ec38c","135":"ef95e3b70867d81551f5","136":"7fcb307a0ba009b6a8ec","137":"3cb6ddf118f771d1216e","138":"11f2d5aa106e52663b48","139":"350387b4440ae927a0bc","140":"f246a975dc2b0edcf99b","141":"57309d06104461b3ffdf","142":"c2577314bdbe76c49dbf","143":"883b71278d6fe88b9837","144":"a819b9f536aa36a77862","145":"10d281b316a3524b4471","146":"e945976085dd853fceaa","147":"b57a5c82202fd1e71c01","148":"27c1928ec2474ed8e94d","149":"578f97274770b21111c3","150":"045fd5da2a61d0a578d0","151":"6c21e30f22538e79df53","152":"2066c1ad28ba1e24def5","153":"7ee76b09baca3136837b","154":"f9e23275b6a479f4f851","155":"7df9e375cb181f695fd5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		var threw = true;
 		try {
 			modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 			threw = false;
 		} finally {
 			if(threw) delete installedModules[moduleId];
 		}

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"45":1,"46":1,"48":1,"50":1,"55":1,"56":1,"57":1,"58":1,"60":1,"61":1,"62":1,"63":1,"72":1,"74":1,"139":1,"140":1,"142":1,"143":1,"144":1,"145":1,"146":1,"147":1,"148":1,"149":1,"150":1,"151":1,"154":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + {"0":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"1249ca0e56183c3725b2","46":"9a7d7057e51b7fdb5ccb","47":"31d6cfe0d16ae931b73c","48":"a98420ed4ce9fe4278ff","49":"31d6cfe0d16ae931b73c","50":"a98420ed4ce9fe4278ff","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","55":"6fa308c32e64770d8b5d","56":"6fa308c32e64770d8b5d","57":"a98420ed4ce9fe4278ff","58":"af3ad95c179c89db825d","59":"31d6cfe0d16ae931b73c","60":"af3ad95c179c89db825d","61":"a98420ed4ce9fe4278ff","62":"c48cdba4d1aa30c4d508","63":"c48cdba4d1aa30c4d508","72":"a98420ed4ce9fe4278ff","73":"31d6cfe0d16ae931b73c","74":"af3ad95c179c89db825d","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","126":"31d6cfe0d16ae931b73c","127":"31d6cfe0d16ae931b73c","128":"31d6cfe0d16ae931b73c","129":"31d6cfe0d16ae931b73c","130":"31d6cfe0d16ae931b73c","131":"31d6cfe0d16ae931b73c","132":"31d6cfe0d16ae931b73c","133":"31d6cfe0d16ae931b73c","134":"31d6cfe0d16ae931b73c","135":"31d6cfe0d16ae931b73c","136":"31d6cfe0d16ae931b73c","137":"31d6cfe0d16ae931b73c","138":"31d6cfe0d16ae931b73c","139":"6fa308c32e64770d8b5d","140":"6fa308c32e64770d8b5d","141":"31d6cfe0d16ae931b73c","142":"af3ad95c179c89db825d","143":"1249ca0e56183c3725b2","144":"6fa308c32e64770d8b5d","145":"9a7d7057e51b7fdb5ccb","146":"af3ad95c179c89db825d","147":"5650f4f6f435f156cc9f","148":"a98420ed4ce9fe4278ff","149":"a98420ed4ce9fe4278ff","150":"a98420ed4ce9fe4278ff","151":"c48cdba4d1aa30c4d508","152":"31d6cfe0d16ae931b73c","153":"31d6cfe0d16ae931b73c","154":"a98420ed4ce9fe4278ff","155":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
